import { CartItem } from '@/models/cart/cart-item'
import { NoveltyCampaign } from '@/models/novelty/novelty'
import { CreditcardServiceForPurchase } from '@/services/api/creditcard'
import { OrderContext } from '@spa/components/pages/order/model/context/order-context'
import _ from 'lodash'

export interface ContextDependencies {
  novelty: NoveltyCampaign | null,
}

/**
 * 単発注文のコンテキスト表現.
 *
 * 通常商品・予約商品といった、各種商品を購入する時に使用する.
 *
 * @see {SubscriptionContext} サブスクリプション契約において利用されるコンテキスト.
 */
export class OnceOrderContext implements OrderContext {
  static build(deps: ContextDependencies = { novelty: null }): OnceOrderContext {
    return new OnceOrderContext(deps)
  }

  private constructor(
    private readonly deps: ContextDependencies
  ) {}

  get title(): string {
    return 'ご注文内容の確認'
  }

  get path() {
    return {
      confirmPage: '/order',

      editPayment: '/order/edit/payment',
      addCreditCard: '/order/edit/payment/new-creditcard',

      editContact: '/order/edit/contact',
      addContact: '/order/edit/new-contact',

      completeProfile: '/order/complete-profile',

      orderComplete: '/order/complete',
    }
  }

  get filter() {
    return {
      cartItems: (items: CartItem[]): CartItem[] => {
        if (!this.deps.novelty) {
          return items
        }

        /**
         * カートに入っているにノベルティ商品の内、現在公開されているノベルティの商品のみ抽出.
         * 過去に公開されていたノベルティの商品が残っている場合に、
         * 過去のノベルティは注文に入れないようにするため.
         */

        const noveltySkuIds = this.deps.novelty.noveltyList.map(n => n.skuId)

        return items.filter((cart) => {
          if (!cart.isNovelty) {
            return true
          }

          return _.includes(noveltySkuIds, cart.skuId)
        })
      },
    }
  }

  get factory() {
    return {
      service: {
        creditCard() {
          return new CreditcardServiceForPurchase()
        },
      },
    }
  }
}
